module.exports = __webpack_public_path__ + "images/icons_v2/juul-mark-baseline-filled-a368b8e7.svg";